// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-07582bf6] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.button-vue.icon-collapse[data-v-07582bf6] {
  position: relative;
  z-index: 105;
  color: var(--color-main-text);
  right: 0;
}
.button-vue.icon-collapse--open[data-v-07582bf6] {
  color: var(--color-main-text);
}
.button-vue.icon-collapse--open[data-v-07582bf6]:hover {
  color: var(--color-primary-element);
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-86815ca2] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation-entry[data-v-86815ca2] {
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  transition: background-color var(--animation-quick) ease-in-out;
  transition: background-color .2s ease-in-out;
  border-radius: var(--border-radius-pill);
}
.app-navigation-entry-wrapper[data-v-86815ca2] {
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
}
.app-navigation-entry-wrapper.app-navigation-entry--collapsible:not(.app-navigation-entry--opened) > ul[data-v-86815ca2] {
  display: none;
}
.app-navigation-entry.active[data-v-86815ca2] {
  background-color: var(--color-primary-element) !important;
}
.app-navigation-entry.active[data-v-86815ca2]:hover {
  background-color: var(--color-primary-element-hover) !important;
}
.app-navigation-entry.active .app-navigation-entry-link[data-v-86815ca2],
.app-navigation-entry.active .app-navigation-entry-button[data-v-86815ca2] {
  color: var(--color-primary-element-text) !important;
}
.app-navigation-entry[data-v-86815ca2]:focus-within,
.app-navigation-entry[data-v-86815ca2]:hover {
  background-color: var(--color-background-hover);
}
.app-navigation-entry.active .app-navigation-entry__children[data-v-86815ca2],
.app-navigation-entry:focus-within .app-navigation-entry__children[data-v-86815ca2],
.app-navigation-entry:hover .app-navigation-entry__children[data-v-86815ca2] {
  background-color: var(--color-main-background);
}
.app-navigation-entry.active .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],
.app-navigation-entry.app-navigation-entry--deleted .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],
.app-navigation-entry:focus .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],
.app-navigation-entry:focus-within .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],
.app-navigation-entry:hover .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2] {
  display: inline-block;
}
.app-navigation-entry.app-navigation-entry--deleted > ul[data-v-86815ca2] {
  display: none;
}
.app-navigation-entry:not(.app-navigation-entry--editing) .app-navigation-entry-link[data-v-86815ca2],
.app-navigation-entry:not(.app-navigation-entry--editing) .app-navigation-entry-button[data-v-86815ca2] {
  padding-right: 14px;
}
.app-navigation-entry .app-navigation-entry-link[data-v-86815ca2],
.app-navigation-entry .app-navigation-entry-button[data-v-86815ca2] {
  z-index: 100;
  display: flex;
  overflow: hidden;
  flex: 1 1 0;
  box-sizing: border-box;
  min-height: 44px;
  padding: 0;
  white-space: nowrap;
  color: var(--color-main-text);
  background-repeat: no-repeat;
  background-position: 14px center;
  background-size: 16px 16px;
  line-height: 44px;
}
.app-navigation-entry .app-navigation-entry-link .app-navigation-entry-icon[data-v-86815ca2],
.app-navigation-entry .app-navigation-entry-button .app-navigation-entry-icon[data-v-86815ca2] {
  display: flex;
  align-items: center;
  flex: 0 0 44px;
  justify-content: center;
  width: 44px;
  height: 44px;
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: 14px center;
}
.app-navigation-entry .app-navigation-entry-link .app-navigation-entry__name[data-v-86815ca2],
.app-navigation-entry .app-navigation-entry-button .app-navigation-entry__name[data-v-86815ca2] {
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.app-navigation-entry .app-navigation-entry-link .editingContainer[data-v-86815ca2],
.app-navigation-entry .app-navigation-entry-button .editingContainer[data-v-86815ca2] {
  width: calc(100% - 44px);
  margin: auto;
}
.app-navigation-entry .app-navigation-entry-link[data-v-86815ca2]:focus-visible,
.app-navigation-entry .app-navigation-entry-button[data-v-86815ca2]:focus-visible {
  box-shadow: 0 0 0 4px var(--color-main-background);
  outline: 2px solid var(--color-main-text);
  border-radius: var(--border-radius-pill);
}
.app-navigation-entry__children[data-v-86815ca2] {
  position: relative;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  width: 100%;
  gap: var(--default-grid-baseline, 4px);
}
.app-navigation-entry__children .app-navigation-entry[data-v-86815ca2] {
  display: inline-flex;
  flex-wrap: wrap;
  padding-left: 16px;
}
.app-navigation-entry__deleted[data-v-86815ca2] {
  display: inline-flex;
  flex: 1 1 0;
  padding-left: 30px !important;
}
.app-navigation-entry__deleted .app-navigation-entry__deleted-description[data-v-86815ca2] {
  position: relative;
  overflow: hidden;
  flex: 1 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 44px;
}
.app-navigation-entry__utils[data-v-86815ca2] {
  display: flex;
  min-width: 44px;
  align-items: center;
  flex: 0 1 auto;
  justify-content: flex-end;
}
.app-navigation-entry__utils.app-navigation-entry__utils--display-actions .action-item.app-navigation-entry__actions[data-v-86815ca2] {
  display: inline-block;
}
.app-navigation-entry__utils .app-navigation-entry__counter-wrapper[data-v-86815ca2] {
  margin-right: calc(var(--default-grid-baseline) * 3);
  display: flex;
  align-items: center;
  flex: 0 1 auto;
}
.app-navigation-entry__utils .action-item.app-navigation-entry__actions[data-v-86815ca2] {
  display: none;
}
.app-navigation-entry--editing .app-navigation-entry-edit[data-v-86815ca2] {
  z-index: 250;
  opacity: 1;
}
.app-navigation-entry--deleted .app-navigation-entry-deleted[data-v-86815ca2] {
  z-index: 250;
  transform: translate(0);
}
.app-navigation-entry--pinned[data-v-86815ca2] {
  order: 2;
  margin-top: auto;
}
.app-navigation-entry--pinned ~ .app-navigation-entry--pinned[data-v-86815ca2] {
  margin-top: 0;
}
[data-themes*=highcontrast] .app-navigation-entry[data-v-86815ca2]:active {
  background-color: var(--color-primary-element-light-hover) !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationItem-hYyNqvah.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;AACrC;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,+DAA+D;EAC/D,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,mDAAmD;AACrD;AACA;;EAEE,+CAA+C;AACjD;AACA;;;EAGE,8CAA8C;AAChD;AACA;;;;;EAKE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,wBAAwB;EACxB,YAAY;AACd;AACA;;EAEE,kDAAkD;EAClD,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qEAAqE;AACvE","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-07582bf6] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.button-vue.icon-collapse[data-v-07582bf6] {\n  position: relative;\n  z-index: 105;\n  color: var(--color-main-text);\n  right: 0;\n}\n.button-vue.icon-collapse--open[data-v-07582bf6] {\n  color: var(--color-main-text);\n}\n.button-vue.icon-collapse--open[data-v-07582bf6]:hover {\n  color: var(--color-primary-element);\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-86815ca2] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation-entry[data-v-86815ca2] {\n  position: relative;\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 44px;\n  transition: background-color var(--animation-quick) ease-in-out;\n  transition: background-color .2s ease-in-out;\n  border-radius: var(--border-radius-pill);\n}\n.app-navigation-entry-wrapper[data-v-86815ca2] {\n  position: relative;\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n}\n.app-navigation-entry-wrapper.app-navigation-entry--collapsible:not(.app-navigation-entry--opened) > ul[data-v-86815ca2] {\n  display: none;\n}\n.app-navigation-entry.active[data-v-86815ca2] {\n  background-color: var(--color-primary-element) !important;\n}\n.app-navigation-entry.active[data-v-86815ca2]:hover {\n  background-color: var(--color-primary-element-hover) !important;\n}\n.app-navigation-entry.active .app-navigation-entry-link[data-v-86815ca2],\n.app-navigation-entry.active .app-navigation-entry-button[data-v-86815ca2] {\n  color: var(--color-primary-element-text) !important;\n}\n.app-navigation-entry[data-v-86815ca2]:focus-within,\n.app-navigation-entry[data-v-86815ca2]:hover {\n  background-color: var(--color-background-hover);\n}\n.app-navigation-entry.active .app-navigation-entry__children[data-v-86815ca2],\n.app-navigation-entry:focus-within .app-navigation-entry__children[data-v-86815ca2],\n.app-navigation-entry:hover .app-navigation-entry__children[data-v-86815ca2] {\n  background-color: var(--color-main-background);\n}\n.app-navigation-entry.active .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],\n.app-navigation-entry.app-navigation-entry--deleted .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],\n.app-navigation-entry:focus .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],\n.app-navigation-entry:focus-within .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2],\n.app-navigation-entry:hover .app-navigation-entry__utils .app-navigation-entry__actions[data-v-86815ca2] {\n  display: inline-block;\n}\n.app-navigation-entry.app-navigation-entry--deleted > ul[data-v-86815ca2] {\n  display: none;\n}\n.app-navigation-entry:not(.app-navigation-entry--editing) .app-navigation-entry-link[data-v-86815ca2],\n.app-navigation-entry:not(.app-navigation-entry--editing) .app-navigation-entry-button[data-v-86815ca2] {\n  padding-right: 14px;\n}\n.app-navigation-entry .app-navigation-entry-link[data-v-86815ca2],\n.app-navigation-entry .app-navigation-entry-button[data-v-86815ca2] {\n  z-index: 100;\n  display: flex;\n  overflow: hidden;\n  flex: 1 1 0;\n  box-sizing: border-box;\n  min-height: 44px;\n  padding: 0;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  background-repeat: no-repeat;\n  background-position: 14px center;\n  background-size: 16px 16px;\n  line-height: 44px;\n}\n.app-navigation-entry .app-navigation-entry-link .app-navigation-entry-icon[data-v-86815ca2],\n.app-navigation-entry .app-navigation-entry-button .app-navigation-entry-icon[data-v-86815ca2] {\n  display: flex;\n  align-items: center;\n  flex: 0 0 44px;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background-size: 16px 16px;\n  background-repeat: no-repeat;\n  background-position: 14px center;\n}\n.app-navigation-entry .app-navigation-entry-link .app-navigation-entry__name[data-v-86815ca2],\n.app-navigation-entry .app-navigation-entry-button .app-navigation-entry__name[data-v-86815ca2] {\n  overflow: hidden;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.app-navigation-entry .app-navigation-entry-link .editingContainer[data-v-86815ca2],\n.app-navigation-entry .app-navigation-entry-button .editingContainer[data-v-86815ca2] {\n  width: calc(100% - 44px);\n  margin: auto;\n}\n.app-navigation-entry .app-navigation-entry-link[data-v-86815ca2]:focus-visible,\n.app-navigation-entry .app-navigation-entry-button[data-v-86815ca2]:focus-visible {\n  box-shadow: 0 0 0 4px var(--color-main-background);\n  outline: 2px solid var(--color-main-text);\n  border-radius: var(--border-radius-pill);\n}\n.app-navigation-entry__children[data-v-86815ca2] {\n  position: relative;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--default-grid-baseline, 4px);\n}\n.app-navigation-entry__children .app-navigation-entry[data-v-86815ca2] {\n  display: inline-flex;\n  flex-wrap: wrap;\n  padding-left: 16px;\n}\n.app-navigation-entry__deleted[data-v-86815ca2] {\n  display: inline-flex;\n  flex: 1 1 0;\n  padding-left: 30px !important;\n}\n.app-navigation-entry__deleted .app-navigation-entry__deleted-description[data-v-86815ca2] {\n  position: relative;\n  overflow: hidden;\n  flex: 1 1 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  line-height: 44px;\n}\n.app-navigation-entry__utils[data-v-86815ca2] {\n  display: flex;\n  min-width: 44px;\n  align-items: center;\n  flex: 0 1 auto;\n  justify-content: flex-end;\n}\n.app-navigation-entry__utils.app-navigation-entry__utils--display-actions .action-item.app-navigation-entry__actions[data-v-86815ca2] {\n  display: inline-block;\n}\n.app-navigation-entry__utils .app-navigation-entry__counter-wrapper[data-v-86815ca2] {\n  margin-right: calc(var(--default-grid-baseline) * 3);\n  display: flex;\n  align-items: center;\n  flex: 0 1 auto;\n}\n.app-navigation-entry__utils .action-item.app-navigation-entry__actions[data-v-86815ca2] {\n  display: none;\n}\n.app-navigation-entry--editing .app-navigation-entry-edit[data-v-86815ca2] {\n  z-index: 250;\n  opacity: 1;\n}\n.app-navigation-entry--deleted .app-navigation-entry-deleted[data-v-86815ca2] {\n  z-index: 250;\n  transform: translate(0);\n}\n.app-navigation-entry--pinned[data-v-86815ca2] {\n  order: 2;\n  margin-top: auto;\n}\n.app-navigation-entry--pinned ~ .app-navigation-entry--pinned[data-v-86815ca2] {\n  margin-top: 0;\n}\n[data-themes*=highcontrast] .app-navigation-entry[data-v-86815ca2]:active {\n  background-color: var(--color-primary-element-light-hover) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
